import React, { useMemo } from "react";
import {
    GiftingCartError,
    buildErrorPagePropsForErrorType,
    GIFTING_CART_ERROR_TYPE,
    useEffectOnce,
} from "@swiggy-private/core-ui";
import { goToGiftingHome } from "@swiggy-private/checkout-core";

export const EmptyGiftingCartError = ({ nrEventHandler }: { nrEventHandler?: (screenType: string) => void }) => {
    const props = useMemo(() => {
        const errorProps = buildErrorPagePropsForErrorType({
            primaryActionOnClick: goToGiftingHome,
        });
        return errorProps[GIFTING_CART_ERROR_TYPE.EMPTY_CART];
    }, []);

    useEffectOnce(() => {
        nrEventHandler?.(GIFTING_CART_ERROR_TYPE.EMPTY_CART);
    });

    return <GiftingCartError {...props} />;
};
